import processEvent from 'analytics/processEvent';
import anaConsts from 'analytics/constants';
import anaUtils from 'analytics/utils';
import { NAV_SOURCES } from 'ai/analytics/events';

export function trackLanding(source, selectedPrompt) {
    const trackingData = {
        pageName: anaConsts.SUPER_CHAT.SUPERCHAT_LANDING
    };

    if (source === NAV_SOURCES.HEADER) {
        trackingData.navigationInfo = `top nav:${anaConsts.SUPER_CHAT.SUPERCHAT}${anaConsts.SUPER_CHAT.SUPERCHAT}${anaConsts.SUPER_CHAT.SUPERCHAT}superchat`;
    } else if (source === NAV_SOURCES.BOTTOM_NAV) {
        trackingData.navigationInfo = `bottom nav:${anaConsts.SUPER_CHAT.SUPERCHAT}${anaConsts.SUPER_CHAT.SUPERCHAT}${anaConsts.SUPER_CHAT.SUPERCHAT}superchat`;
    }

    if (selectedPrompt) {
        trackingData.actionInfo = `${anaConsts.SUPER_CHAT.SUPERCHAT_PROMPT}${selectedPrompt}`;
    }

    processEvent.process(anaConsts.LINK_TRACKING_EVENT, { data: trackingData });
}

export function trackLandingAsync(source) {
    const trackingData = {
        pageName: anaConsts.SUPER_CHAT.SUPERCHAT_LANDING
    };

    if (source === NAV_SOURCES.BOTTOM_NAV) {
        trackingData.navigationInfo = `bottom nav:${anaConsts.SUPER_CHAT.SUPERCHAT}${anaConsts.SUPER_CHAT.SUPERCHAT}${anaConsts.SUPER_CHAT.SUPERCHAT}superchat`;
    }

    processEvent.process(anaConsts.ASYNC_PAGE_LOAD, { data: trackingData });
}

export function trackExit() {
    processEvent.process(anaConsts.LINK_TRACKING_EVENT, {
        data: {
            pageName: anaConsts.SUPER_CHAT.SUPERCHAT_LANDING,
            actionInfo: anaConsts.SUPER_CHAT.SUPERCHAT_EXIT
        }
    });
}

export function trackFlyoutOpen() {
    processEvent.process(anaConsts.ASYNC_PAGE_LOAD, {
        data: {
            ...anaUtils.getLastAsyncPageLoadData(),
            pageName: anaConsts.SUPER_CHAT.SUPERCHAT_FLYOUT
        }
    });
}

export function trackMenuToggle(isMenuOpen) {
    const pageName = isMenuOpen
        ? anaConsts.SUPER_CHAT.SUPERCHAT_MENU
        : anaConsts.SUPER_CHAT.SUPERCHAT_LANDING;

    processEvent.process(anaConsts.ASYNC_PAGE_LOAD, {
        data: { pageName }
    });
}

export function buildLandingTrackingData(source, selectedPrompt) {
    const trackingData = {
        pageName: anaConsts.SUPER_CHAT.SUPERCHAT_LANDING
    };

    if (source === NAV_SOURCES.HEADER) {
        trackingData.navigationInfo = `top nav:${anaConsts.SUPER_CHAT.SUPERCHAT}${anaConsts.SUPER_CHAT.SUPERCHAT}${anaConsts.SUPER_CHAT.SUPERCHAT}superchat`;
    } else if (source === NAV_SOURCES.BOTTOM_NAV) {
        trackingData.navigationInfo = `bottom nav:${anaConsts.SUPER_CHAT.SUPERCHAT}${anaConsts.SUPER_CHAT.SUPERCHAT}${anaConsts.SUPER_CHAT.SUPERCHAT}superchat`;
    }

    if (selectedPrompt) {
        trackingData.actionInfo = `${anaConsts.SUPER_CHAT.SUPERCHAT_PROMPT}${selectedPrompt}`;
    }

    return trackingData;
}

export function trackLandingPLP(promptText = null) {
    const data = {
        pageName: anaConsts.SUPER_CHAT.SUPERCHAT_LANDING
    };

    if (promptText) {
        data.actionInfo = `${anaConsts.SUPER_CHAT.SUPERCHAT_PROMPT}${promptText}`; // prop55
    } else if (typeof digitalData !== 'undefined' && digitalData) {
        data.searchTerm = digitalData.page?.attributes?.search?.searchTerm; // prop4
    }

    processEvent.process(anaConsts.LINK_TRACKING_EVENT, { data });
}
